/**
 * LiftCloud refuses with 409 a write that would put an uploaded MCE mapping on a
 * server that cannot read one, and names those servers in `servers`. Any bank,
 * channel or adapter write can meet it, so every path shows this one sentence.
 */

/** The servers a refusal names, from an error's `data` or a parsed body. */
export function refusedServersIn(data: unknown): string[] {
  if (typeof data !== "object" || data === null || !("servers" in data)) return [];
  const { servers } = data;
  return Array.isArray(servers) ? servers.map(String) : [];
}

/** One plain sentence naming the servers that must be updated first. */
export function serversMessage(servers: string[]): string {
  return `This adapter cannot be sent to ${servers.join(", ")} until ${
    servers.length === 1 ? "that server is" : "those servers are"
  } updated. Update ${servers.length === 1 ? "it" : "them"} and try again.`;
}

/** An RTK error with its message replaced when it is a scope refusal; otherwise the same error. */
export function withScopeRefusalMessage<E>(error: E): E {
  if (typeof error !== "object" || error === null || !("data" in error)) return error;
  const servers = refusedServersIn(error.data);
  if (servers.length === 0) return error;
  return { ...error, data: { ...(error.data as object), message: serversMessage(servers) } };
}
